export function normalizeWinRatePnl(value: unknown): number {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : 0;
}

export function calculateWinRatePercent(wins: number, losses: number): number {
  const denominator = wins + losses;
  return denominator > 0 ? (wins / denominator) * 100 : 0;
}

export function calculateWinRateRatio(wins: number, losses: number): number {
  const denominator = wins + losses;
  return denominator > 0 ? wins / denominator : 0;
}

export function countWinLossBreakeven<T>(
  rows: T[],
  getPnl: (row: T) => unknown,
): { wins: number; losses: number; breakeven: number } {
  return rows.reduce(
    (counts, row) => {
      const pnl = normalizeWinRatePnl(getPnl(row));
      if (pnl > 0) counts.wins += 1;
      else if (pnl < 0) counts.losses += 1;
      else counts.breakeven += 1;
      return counts;
    },
    { wins: 0, losses: 0, breakeven: 0 },
  );
}

export function addWinLossCount<T extends { wins: number; losses: number }>(bucket: T, pnlValue: unknown): T {
  const pnl = normalizeWinRatePnl(pnlValue);
  if (pnl > 0) bucket.wins += 1;
  else if (pnl < 0) bucket.losses += 1;
  return bucket;
}
